import * as React from "react";
import { LogNodeModel } from "../../../models/logNodeModel";
import LogFilesView from './logFilesView';
import LogFileService from '../../../services/logFileService';
import Spinner from '../../../common/components/spinner/spinner';
import { TreeNodeModel } from '../../../models/treeNodeModel';
import { Button } from 'primereact/button';
import { ContextMenu } from 'primereact/contextmenu';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import FileSaver from 'file-saver';
import Translate from '../../../common/functions/translate';
import Snackbar from "../../../common/components/snackbar/snackbar";
import Paper from '@material-ui/core/Paper';

interface IProps {
}

interface IState {
    listLogNodes: Array<LogNodeModel>;
    treeLogNodes: Array<TreeNodeModel>;
    isLoading: boolean;
    validationMessage: string;
    isVisibleDialog: boolean;
    isVisibleDialogWrap: boolean;
    isVisibleConfirmDialog: boolean;
    selectionKeys: any;
    selectedLogNodeIds: Array<string>;
    contextMenu: any;
    currentFileLogNode: LogNodeModel;
    lastFileLogNode: LogNodeModel;
    expandedKeys: any;
}

class LogFilesContainer extends React.Component<IProps, IState> {
    logFileService = new LogFileService();
    messages: any;
    growl: any;
    cm: any;
    snackbar: any;

    constructor(props: IProps) {
        super(props);

        const menu = [
            {
                label: Translate('Download'),
                icon: 'pi pi-download',
                command: () => { this.handleViewClick(this.state.selectionKeys) }
            }
        ];

        this.state = {
            validationMessage: '',
            listLogNodes: new Array<LogNodeModel>(0),
            treeLogNodes: new Array<TreeNodeModel>(0),
            isLoading: false,
            isVisibleDialog: false,
            isVisibleDialogWrap: false,
            isVisibleConfirmDialog: false,
            selectionKeys: null,
            selectedLogNodeIds: new Array<string>(0),
            contextMenu: menu,
            currentFileLogNode: new LogNodeModel(),
            lastFileLogNode: new LogNodeModel(),
            expandedKeys: null,
        };
    }

    // events
    componentDidMount() {
        this.getAllLogNodes();
    }

    handleViewClick = id => {
        this.setState({ isLoading: true });

        let logNode = this.state.listLogNodes.find(n => n.itemId === id);
        if (logNode && logNode.nodeType === 'Archive') {
            this.logFileService.getLogFileData(logNode)
                .then(
                    (data) => {
                        let res = new Blob([data], { type: 'application/json' });
                        FileSaver.saveAs(res, logNode ? logNode.name : "undefined.log");

                        this.setState({ isLoading: false });
                    },
                    error => {
                        this.snackbar.show({ severity: 'error', summary: error.message });
                        this.setState({ isLoading: false });
                    }
                );
        }
        else {
            this.snackbar.show({ severity: 'error', summary: Translate('Can not view directories!') });
            this.setState({ isLoading: false });
        }
    };

    handleSelectionChange = (value) => {
        let logNodeIds = new Array<string>(0);
        logNodeIds.push(value);

        this.setState({
            selectionKeys: value,
            selectedLogNodeIds: logNodeIds.slice()
        });

        let currentNode = this.state.listLogNodes.find(n => n.itemId === value);
        if (currentNode && currentNode.nodeType === 'Archive') {
            this.setCurrentLogNode(currentNode);
        } else {
            this.setCurrentLogNode(new LogNodeModel());
        }
    }

    setCurrentLogNode(logNode: LogNodeModel) {
        this.setState({ currentFileLogNode: { ...logNode } });
    }

    // methods
    getAllLogNodes() {
        this.setState({ isLoading: true });

        this.logFileService.getAllNodes().then(
            (data: Array<LogNodeModel>) => {
                this.setState({
                    isLoading: false,
                    listLogNodes: data
                });
                this.createTree();
                this.setLastLogFile();
                this.expandToLastNode();
            })
            .catch(error => {
                this.snackbar.show({ severity: 'error', summary: error.message });
                this.setState({ isLoading: false });
            });
    }

    setLastLogFile() {
        let sortedFileNodes = this.state.listLogNodes.filter(i => i.nodeType === "Archive" && i.fullPath.includes('AppLog')).sort(function (a, b) {
            var fileNameA = a.name.toLowerCase(), fileNameB = b.name.toLowerCase();
            if (fileNameA < fileNameB) return -1;
            if (fileNameA > fileNameB) return 1;
            return 0;
        });

        if (sortedFileNodes && sortedFileNodes.length > 0) {
            let lastFileNode = sortedFileNodes[sortedFileNodes.length - 1];
            this.setState({ lastFileLogNode: lastFileNode });
        }
    }

    createTree() {
        let subTree = this.createSubTree(null);
        this.setState({ treeLogNodes: subTree });
    }

    createSubTree(parentItemId) {
        let subTree = new Array<TreeNodeModel>(0);

        this.state.listLogNodes
            .filter(f => parentItemId ? f.parentItemId === parentItemId : f.parentItemId === null)
            .sort((a, b) => (a.orderNo > b.orderNo) ? 1 : (b.orderNo > a.orderNo ? -1 : 0))
            .map(f => {
                let node = new TreeNodeModel();
                node.key = f.itemId;

                if (f.nodeType === "Directory") {
                    node.label = f.name
                }
                else {
                    node.label = f.name + " (" + HelperFunctions.formatBytes(f.fileSizeInBytes, 1) + ")";
                }

                node.data = { ...f };
                node.icon = f.nodeType === "Directory" ? "pi pi-folder" : "pi pi-file";
                if (this.state.listLogNodes.some(a => a.parentItemId === f.itemId)) {
                    node.children = this.createSubTree(f.itemId);
                };
                subTree.push(node);
                return 0;
            });

        return subTree;
    }

    expandToLastNode = () => {
        let lastLog = this.state.lastFileLogNode;

        let currentItemId = lastLog && lastLog.itemId ? lastLog.itemId : null;
        if (currentItemId) {
            let expandedKeys = this.returnNodesToExpand(this.state.expandedKeys, currentItemId);
            this.setState({ expandedKeys: expandedKeys });
        }
    }

    returnNodesToExpand = (expandedKeys, itemId) => {
        expandedKeys = expandedKeys ? expandedKeys : {};

        let currentNode = this.state.listLogNodes.find(p => p.itemId === itemId);
        if (currentNode) {
            expandedKeys[currentNode.itemId.toString()] = true;
            if (currentNode.parentItemId != null || undefined) {
                this.returnNodesToExpand(expandedKeys, currentNode.parentItemId);
            }
        }

        return expandedKeys;
    }

    public render() {

        const { treeLogNodes, isLoading, selectionKeys, selectedLogNodeIds, currentFileLogNode, lastFileLogNode, expandedKeys } = this.state;

        let lastLogElement: any = null;

        if (lastFileLogNode) {
            lastLogElement =
                <Button
                    icon="pi pi-download"
                    label={Translate("View last") + " - " + lastFileLogNode.name}
                    className="p-button-success"
                    onClick={() => this.handleViewClick(lastFileLogNode.itemId)}
                />
        } else {
            lastLogElement =
                <Button
                    label={Translate("No files detected")}
                    className="p-button-success"
                    disabled={true}
                />
        }

        let currentLogElement: any = null;

        if (currentFileLogNode && currentFileLogNode.name) {
            currentLogElement =
                <Button
                    icon="pi pi-download"
                    style={{ marginLeft: "5px" }}
                    label={Translate("View current") + " - " + currentFileLogNode.name}
                    className="p-button-info"
                    onClick={() => this.handleViewClick(currentFileLogNode.itemId)}
                />
        } else {
            currentLogElement =
                <Button
                    style={{ marginLeft: "5px" }}
                    label={Translate("No file selected")}
                    className="p-button-info"
                    disabled={true}
                />
        }

        return (
            <div>
                <h1>{Translate("Logs")}</h1>
                {isLoading ? <Spinner /> : null}
                <Snackbar ref={(el) => this.snackbar = el} />

                <div className="mb-2">
                    {lastLogElement}
                    {currentLogElement}
                </div>

                <ContextMenu model={this.state.contextMenu} ref={el => this.cm = el} />
                <Paper style={{ padding: 10, backgroundColor: "#f5f5f5" }} >
                    <LogFilesView
                        treeLogNodes={treeLogNodes}
                        selectionKeys={selectionKeys}
                        handleSelectionChange={this.handleSelectionChange}
                        onContextMenu={event => (selectedLogNodeIds && selectedLogNodeIds.length > 0 ? this.cm.show(event.originalEvent) : null)}
                        expandedKeys={expandedKeys}
                        onToggle={e => this.setState({ expandedKeys: e.value })}
                    />
                </Paper>
            </div>
        );
    }
}

export default LogFilesContainer;